import {
  ExternalConnection,
  LinkedItemGoal,
  TaskCalendarOverride,
  TaskCalendarOverrideWrite,
} from '@griply/types';
import { GetTaskCalendarSyncCandidatesOptions } from '@griply/utils';
import { useCallback } from 'react';

export type BuildTaskCalendarOverrideWrites = (options: {
  task: GetTaskCalendarSyncCandidatesOptions['task'];
  connections: ExternalConnection[];
  goals: LinkedItemGoal[];
  patch: Partial<TaskCalendarOverride>;
}) => TaskCalendarOverrideWrite[];

export type UseSetTaskCalendarOverrideOptions = {
  connections: ExternalConnection[];
  goals: LinkedItemGoal[];
  // Injected: the write-payload builder lives in @griply/services, which this package may not import.
  buildWrites: BuildTaskCalendarOverrideWrites;
  mutate: (write: TaskCalendarOverrideWrite) => void;
};

export const useSetTaskCalendarOverride = ({
  connections,
  goals,
  buildWrites,
  mutate,
}: UseSetTaskCalendarOverrideOptions) =>
  useCallback(
    (
      task: GetTaskCalendarSyncCandidatesOptions['task'],
      patch: Partial<TaskCalendarOverride>,
    ) =>
      buildWrites({ task, connections, goals, patch }).forEach((write) =>
        mutate(write),
      ),
    [buildWrites, mutate, connections, goals],
  );
